module.exports = __webpack_public_path__ + "img/camera-circle.81d67699.svg";